import  React from 'react';
import Link from 'react-router-dom/Link';

export default ({event, children, ...props}) =>
    <Link to={'/wydarzenia/' + event.slug} {...props}>{children}</Link>


// WEBPACK FOOTER //
// ./src/modules/Events/elements/EventLink.js